var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.711,
    height: 25.459,
    viewBox: "0 0 21.711 25.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10758",
    "data-name": "Group 10758",
    transform: "translate(-28.277 -681.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6920",
    "data-name": "Path 6920",
    d: "M40.577,681.921a1.215,1.215,0,0,1,.9.927,1.134,1.134,0,0,1-1.033,1.362c-.041,0-.082.01-.143.017v1.49a11.015,11.015,0,0,1,3.656,1.075c.24-.378.457-.758.714-1.108a1.829,1.829,0,0,1,.551-.516,1.09,1.09,0,0,1,1.3.234,1.11,1.11,0,0,1,.194,1.309c-.246.44-.528.86-.8,1.306a10.8,10.8,0,0,1,4.075,8.474,10.6,10.6,0,0,1-2.06,6.389,10.854,10.854,0,0,1-19.65-6.351,10.9,10.9,0,0,1,9.694-10.812v-1.484c-.111-.015-.217-.021-.319-.046a1.146,1.146,0,0,1-.14-2.191c.061-.023.12-.05.18-.076Zm7.114,14.6a8.554,8.554,0,1,0-8.556,8.547A8.552,8.552,0,0,0,47.691,696.521Z",
    fill: "#cb3d82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6921",
    "data-name": "Path 6921",
    d: "M184.256,845.842a1.181,1.181,0,0,1,.32-.811q1.5-1.721,3-3.439a1.148,1.148,0,1,1,1.739,1.5q-1.505,1.75-3.034,3.479a1.148,1.148,0,0,1-2.029-.727Z",
    transform: "translate(-146.266 -149.322)",
    fill: "#cb3d82"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClock);
export default __webpack_public_path__ + "static/media/ICO-CLOCK.dc71ed09e19b8ddfa3176eda4044c37b.svg";
export { ForwardRef as ReactComponent };